export const white = "#FFFFFF";

export const darkBg = "#212121";

export const black = "#000000";
export const black2 = "rgba(0, 0, 0, 0.87)";

export const blue = "#4791FF";
export const lightBlue = "#7EBAFF";

export const gold = "#FFD950";

export const red = "#FF3B30";
export const darkRed = "#B0001F";

export const green = "#34C759";
export const lightBrown = "#FC8E88";
export const lightGreen = "#D2F9DC";
export const lightGreen2 = "#C0EFC6";
export const lightOrange = "#FFADA8";
export const lightHoney = "#FED2DE";

export const pageTitleBgColor = "#F9F9FB";

export const lineChartGrayColor = "#6A7798";
export const lineChartGreenColor = "#34C759";

export const gray = "#848484";
export const middleGray = "#EFEFF4";
export const lightGray = "#C6C6C8";
export const bordeLightGray = "#BFBFBF";
export const darkGray = "#707070";
export const lightBgGray = "rgba(245,245,245,0.5)";

export const GroupsTableHeaderBgColor = "#F6F6F6";
export const GroupsTableCreatedCellColor = "#8A8A8E";
export const GroupsTitleBorderColor = "#DEDEDE";
export const replyBorderColor = "#AE91FF";

export const stripeCardContainer = "rgb(227 227 227)";

export const borderColor = "#e8e8e8";
